/**
 * Resource that represents a Role.
 *
 * @name Role
 * @class
 * @augments TmrResource
 */
function RoleFactory(TmrApi, TmrResource, TmrTransformResourceAction) {
  'ngInject'
  let actions = {
    get: {},
    save: {},
    bulkCreate: {},
    bulkUpdate: {},
    query: {},
    search: {},
    capabilities: {
      method: 'GET',
      url: TmrApi.endpoint('Role.capabilities'),
      isArray: true,
    },
  }
  let defaultValues = () => ({
    capabilities: [],
    data: {},
    priority: 0,
  })

  for (let name in actions) {
    TmrTransformResourceAction.prependRequest(actions[name], request => {
      Array.isArray(request)
        ? ReplaceProperties(request, 'request')
        : ReplaceProperty(request, 'request')
      return request
    })
    TmrTransformResourceAction.appendResponse(actions[name], response => {
      Array.isArray(response)
        ? ReplaceProperties(response, 'response')
        : ReplaceProperty(response, 'response')
      return response
    })
  }

  //Call Replaceproperty if resource is an Array
  function ReplaceProperties(resource, type) {
    resource.forEach(res => ReplaceProperty(res, type))
    return resource
  }

  //convert data property  request:from Json to string OR response:from string to Json
  function ReplaceProperty(resource, type) {
    if (typeof resource === 'object' && resource.data) {
      resource.data =
        type === 'request'
          ? JSON.stringify(resource.data)
          : JSON.parse(resource.data)
    }
    return resource
  }

  let Role = TmrResource('Role', actions, [], defaultValues)
  return Role
}

export const factory = ['Role', RoleFactory]
